"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidator = exports.validatorList = void 0;
var NUMBERS_ONLY_REGEX = /^[0-9]+$/;
var LAND_PHONE_REGEX = /^[8|9][0-9]{8}$/;
var MOBILE_PHONE_REGEX = /^[6|7][0-9]{8}$/;
var ANY_PHONE_REGEX = /^[6|7|8|9][0-9]{8}$/;
var DNI_REGEX = /^(\d{8})([A-Z])$/;
var NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
var PASSPORT_REGEX = /^[A-PR-WY1-9]{6,18}$/;
var EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var DTS_TEXT_REGEX = /([^\r\n+|\r+|\n+|\t+])*/;
var DTS_EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"À-ÿ]+(\.[^<>()[\]\\.,;:\s@"À-ÿ]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var DTS_PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]){8,100}$/;
var validatorList = {
  REQUIRED: 'required',
  LENGTH: 'length',
  CHECKBOX: 'checkbox',
  NUMBERS_ONLY: 'numbersOnly',
  PHONE: 'phone',
  MOBILE_PHONE: 'mobilePhone',
  ANY_PHONE: 'anyPhone',
  DOC_NUMBER: 'docNumber',
  EMAIL: 'email',
  DTS_TEXT: 'dtsText',
  DTS_EMAIL: 'dtsEmail',
  DTS_PASSWORD: 'dtsPassword'
};
exports.validatorList = validatorList;
var errorTexts = {
  // Required message
  inputRequiredMessage: 'Por favor, rellena este campo',
  // Length messages
  lengthExactMessage: 'El campo debe tener',
  lengthMinMessage: 'El campo debe tener al menos',
  lengthMaxMessage: 'El campo debe tener máximo',
  characterWord: 'caracteres',
  // Checkbox message
  checkboxRequiredMessage: 'Este campo es obligatorio',
  // NumbersOnly message
  invalidNumbersOnlyMessage: 'Tan sólo se permiten números',
  // Phone messages
  phoneInvalidFormat: 'Número fijo no válido',
  mobilePhoneInvalidFormat: 'Número móvil no válido',
  anyPhoneInvalidFormat: 'Número de teléfono no válido',
  // DocTypes messages
  validDocTypesMessage: 'Se permiten los tipos de documento',
  invalidDocType: 'Tipo de documento no permitido',
  docNumberInvalidFormat: 'Documento incorrecto o formato no válido',
  // Email message
  invalidEmailFormat: 'Correo electrónico no válido',
  // Invalid formar message
  invalidFormat: 'Formato no válido',
  // Password message
  invalidDTSPasswordMessage: 'Formato no válido: al menos 8 caracteres que contengan una mayúscula, una minúscula y un número.'
};
var IDENTIFICATION_DOCUMENT_TYPES = {
  NIF: 'NIF',
  DNI: 'DNI',
  NIE: 'NIE',
  PASSPORT: 'PASSPORT'
};

var validateRequired = function validateRequired(value) {
  var validated = true;
  var errorMsg = '';

  if (!value) {
    validated = false;
    errorMsg = errorTexts.inputRequiredMessage;
  }

  return {
    validated: validated,
    errorMsg: errorMsg
  };
};

var validateLength = function validateLength(value, componentProps) {
  var validated = true;
  var errorMsg = '';
  var maxLength = componentProps.maxLength,
      minLength = componentProps.minLength;

  if (minLength && maxLength && minLength === maxLength && value.length !== minLength) {
    validated = false;
    errorMsg = "".concat(errorTexts.lengthExactMessage, " ").concat(minLength, " ").concat(errorTexts.characterWord);
  } else if (minLength && minLength > 0 && value.length < minLength) {
    validated = false;
    errorMsg = "".concat(errorTexts.lengthMinMessage, " ").concat(minLength, " ").concat(errorTexts.characterWord);
  } else if (maxLength && maxLength > 0 && value.length > maxLength) {
    validated = false;
    errorMsg = "".concat(errorTexts.lengthMaxMessage, " ").concat(maxLength, " ").concat(errorTexts.characterWord);
  }

  return {
    validated: validated,
    errorMsg: errorMsg
  };
};

var validateRegex = function validateRegex(value, componentProps, regex, regexErrorMessage) {
  var required = componentProps.required;
  var validated = true;
  var errorMsg = '';

  if (!value && !required) {
    return {
      validated: validated,
      errorMsg: errorMsg
    };
  }

  if (value) {
    validated = regex.test(value);

    if (!validated) {
      errorMsg = regexErrorMessage;
    }
  }

  return {
    validated: validated,
    errorMsg: errorMsg
  };
};

var validateCheckbox = function validateCheckbox(value, componentProps) {
  var required = componentProps.required;
  var validated = true;
  var errorMsg = '';
  var newValue = value === true;

  if (!newValue && required) {
    validated = false;
    errorMsg = errorTexts.checkboxRequiredMessage;
  }

  return {
    validated: validated,
    errorMsg: errorMsg
  };
};

var numbersOnlyValidation = function numbersOnlyValidation(value, componentProps) {
  return validateRegex(value, componentProps, NUMBERS_ONLY_REGEX, errorTexts.invalidNumbersOnlyMessage);
};

var validatePhone = function validatePhone(value, componentProps) {
  return validateRegex(value, componentProps, LAND_PHONE_REGEX, errorTexts.phoneInvalidFormat);
};

var validateMobilePhone = function validateMobilePhone(value, componentProps) {
  return validateRegex(value, componentProps, MOBILE_PHONE_REGEX, errorTexts.mobilePhoneInvalidFormat);
};

var validateAnyPhone = function validateAnyPhone(value, componentProps) {
  return validateRegex(value, componentProps, ANY_PHONE_REGEX, errorTexts.anyPhoneInvalidFormat);
};

var validDNI = function validDNI(docNumber) {
  var dniLetters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  var letter = dniLetters.charAt(parseInt(docNumber, 10) % 23);
  return letter === docNumber.charAt(8);
};

var validNIE = function validNIE(docNumber) {
  // Change the initial letter for the corresponding number and validate as DNI
  var niePrefix = docNumber.charAt(0);

  switch (niePrefix) {
    case 'X':
      niePrefix = 0;
      break;

    case 'Y':
      niePrefix = 1;
      break;

    case 'Z':
      niePrefix = 2;
      break;

    default:
  }

  return validDNI(niePrefix + docNumber.substr(1));
};

var getDocType = function getDocType(docNumber) {
  var docNumberTrimmed = docNumber.toUpperCase().replace(/\s/, '');

  if (docNumberTrimmed.match(DNI_REGEX)) {
    return IDENTIFICATION_DOCUMENT_TYPES.DNI;
  }

  if (docNumberTrimmed.match(NIE_REGEX)) {
    return IDENTIFICATION_DOCUMENT_TYPES.NIE;
  }

  if (docNumberTrimmed.match(PASSPORT_REGEX)) {
    return IDENTIFICATION_DOCUMENT_TYPES.PASSPORT;
  }

  return null;
};

var validateDocTypeFormat = function validateDocTypeFormat(value) {
  // Ensure upcase and remove whitespace
  var docNumber = value.toUpperCase().replace(/\s/, '');
  var valid = false;
  var type = getDocType(docNumber);

  switch (type) {
    case IDENTIFICATION_DOCUMENT_TYPES.DNI:
      valid = validDNI(docNumber);
      break;

    case IDENTIFICATION_DOCUMENT_TYPES.NIE:
      valid = validNIE(docNumber);
      break;

    case IDENTIFICATION_DOCUMENT_TYPES.PASSPORT:
      valid = true;
      break;

    default:
  }

  return valid;
};

var docNumberValidation = function docNumberValidation(value, componentProps) {
  var validated = true;
  var errorMsg = '';
  var docNumberTrimmed = value.toUpperCase().replace(/\s/, '');
  var allowDocTypes = componentProps.allowDocTypes,
      required = componentProps.required;

  if (!docNumberTrimmed && !required) {
    return {
      validated: validated,
      errorMsg: errorMsg
    };
  }

  var docType = getDocType(docNumberTrimmed);
  var docTypeFormatValidation = validateDocTypeFormat(docNumberTrimmed);

  if (allowDocTypes) {
    if (Object.values(allowDocTypes).includes(docType) && docTypeFormatValidation) {
      validated = true;
    } else if (!docTypeFormatValidation) {
      validated = false;
      errorMsg = errorTexts.docNumberInvalidFormat;
    } else {
      validated = false;
      var docTypeNames = [];
      Object.keys(allowDocTypes).forEach(function (docTypeKey) {
        if (IDENTIFICATION_DOCUMENT_TYPES[allowDocTypes[docTypeKey]]) {
          docTypeNames.push(IDENTIFICATION_DOCUMENT_TYPES[allowDocTypes[docTypeKey]]);
        }
      });
      errorMsg = "".concat(errorTexts.validDocTypesMessage, " ").concat(docTypeNames.join(' / '));
    }
  } else {
    validated = false;
    errorMsg = errorTexts.invalidDocType;
  }

  return {
    validated: validated,
    errorMsg: errorMsg
  };
};

var validateEmail = function validateEmail(value, componentProps) {
  return validateRegex(value, componentProps, EMAIL_REGEX, errorTexts.invalidEmailFormat);
};
/* START SPECIFIC DTS VALIDATORS */


var validateDTSText = function validateDTSText(value, componentProps) {
  return validateRegex(value, componentProps, DTS_TEXT_REGEX, errorTexts.invalidFormat);
};

var validateDTSEmail = function validateDTSEmail(value, componentProps) {
  return validateRegex(value, componentProps, DTS_EMAIL_REGEX, errorTexts.invalidEmailFormat);
};

var validateDTSPassword = function validateDTSPassword(value, componentProps) {
  return validateRegex(value, componentProps, DTS_PASSWORD_REGEX, errorTexts.invalidDTSPasswordMessage);
};
/* END SPECIFIC DTS VALIDATORS */

/* Validator mapping begin */


var getValidator = function getValidator(type) {
  switch (type) {
    case validatorList.REQUIRED:
      return validateRequired;

    case validatorList.LENGTH:
      return validateLength;

    case validatorList.NUMBERS_ONLY:
      return numbersOnlyValidation;

    case validatorList.CHECKBOX:
      return validateCheckbox;

    case validatorList.PHONE:
      return validatePhone;

    case validatorList.MOBILE_PHONE:
      return validateMobilePhone;

    case validatorList.ANY_PHONE:
      return validateAnyPhone;

    case validatorList.DOC_NUMBER:
      return docNumberValidation;

    case validatorList.EMAIL:
      return validateEmail;

    case validatorList.DTS_TEXT:
      return validateDTSText;

    case validatorList.DTS_EMAIL:
      return validateDTSEmail;

    case validatorList.DTS_PASSWORD:
      return validateDTSPassword;

    default:
      return null;
  }
};
/* Validator mapping end */


exports.getValidator = getValidator;

//# sourceMappingURL=index.js.map